export default function CreativeBuilderCardController(
  $q,
  $http,
  CreativeGroupService,
  CurrentUserService,
  MixpanelService
) {
  const vm = this;
  vm.duplicateCreative = duplicateCreative;
  vm.deleteCreative = deleteCreative;
  vm.groupService = CreativeGroupService;

  vm.includesDspTracker = function() {
    if (vm.partner.partnerType !== 'DSP') {
      return false;
    }
    return ![
      'banner', 'instream-video'
    ].includes(vm.creative.action);
  };

  vm.handleVideoTypeChange = function handleVideoTypeChange(videoType) {
    vm.videoType = videoType;
  };

  CurrentUserService.get().then(user => {
    vm.userSignedIn = !!user;
  });

  function duplicateCreative() {
    MixpanelService.track('Creative Duplicated');

    const newCreative = JSON.parse(JSON.stringify(vm.creative));
    newCreative.id = null;
    newCreative.name = 'Copy of ' + vm.creative.name;
    CreativeGroupService.addCreativeToList(newCreative);
  }

  function deleteCreative() {
    MixpanelService.track('Creative removed from group');

    if (!vm.creative.id) {
      CreativeGroupService.removeFromList(vm.creative);
      return $q.resolve();
    }

    return $http
      .delete(
        `/creative_groups/${CreativeGroupService.group.id}/creatives/${vm.creative.id}`
      )
      .then(() => {
        CreativeGroupService.removeFromList(vm.creative);
      });
  }

  return vm;
}

CreativeBuilderCardController.$inject = [
  '$q',
  '$http',
  'CreativeGroupService',
  'CurrentUserService',
  'MixpanelService'
];
